import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKategoriAnggota = 'kategori-anggota';
const postKategoriAnggotaUrl = 'kategori-anggota';
const putKategoriAnggota = 'kategori-anggota/';
const deleteKategoriAnggota = 'kategori-anggota/';

class KategoriAnggotaService {
    getKategoriAnggota(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getKategoriAnggota + '?pageNo=' + currentPage  + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            }
        );
    }
    
    getAllKategoriAnggota() {
        return axios.get(
            API_URL + getKategoriAnggota + '?pageNo=0&pageSize=1000&filter=default',
            {
                headers: authHeader()
            }
        );
    }

    postKategoriAnggota(formData) {        
        return axios
        .post(
            API_URL + postKategoriAnggotaUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKategoriAnggota(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKategoriAnggota + formData.idKategoriAnggota, formData,
            { headers: authHeader() }
        );
    }

    deleteKategoriAnggota(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKategoriAnggota + formData.idKategoriAnggota,
                { headers: authHeader() }
            );
    }

}

export default new KategoriAnggotaService();